import {toTimeString} from "../../util/timeutils";
import {Table} from "antd";
import {PaymentStatusWidget} from "../widget/PaymentStatusWidget";
import {PaymentStatusType} from "../../api/Constants";
import {MoneyEntryWidget} from "../sales/MoneyEntryWidget";
import {updateInvoicePaymentAccount, updateInvoicePaymentAmount} from "../../api/Api";
import {BankAccountWidget} from "../widget/BankAccountWidget";

export const InvoicePaymentTable = ({invoice, payments, onRefresh, onApiFail}) => {
    const invoicePayments = payments;

    const onPaymentChange = (payment) => (value) => {

        updateInvoicePaymentAmount(payment.id, value).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const setAccountId = (payment) => (accountId) => {
        updateInvoicePaymentAccount(payment.id, accountId).then(r =>{
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const columns = [
        {
            title: 'Payment Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record, index) => {
                if (record.state === PaymentStatusType.Recorded) {
                    // compute the payments excluding this one
                    let remainingBalance = invoice.amountDue;
                    for (let i=0; i<payments.length; i++) {
                        const payment = payments[i];
                        if (payment.id !== record.id) {
                            remainingBalance -= payment.amount;
                        }
                    }
                    return <MoneyEntryWidget placeholder={'Payment'} value={val} max={remainingBalance} title={'Edit Payment'} onPriceChange={onPaymentChange(record)} />
                } else {
                    return `$ ${val}`
                }
            }
        },
        {
            title: 'Recorded by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val, record, index) => {
                return toTimeString(new Date(val));
            }
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'accountName',
            render: (val, record, index) => {
                if (record.state === PaymentStatusType.Recorded) {
                    return <BankAccountWidget accountName={val} accountId={record.accountId} onRefresh={onRefresh} onApiFail={onApiFail} altText={`Account`} setAccountId={setAccountId(record)}/>
                } else {
                    return val;
                }
            }
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val) => {
                return <PaymentStatusWidget status={val}/>
            }
        }
    ];

    if (invoice === undefined) {
        return <div />
    }

    return <Table dataSource={invoicePayments} columns={columns} pagination={false} />
}